import React from 'react';

import {
	styled
} from 'ps-gui';

const Wrapper = styled.a`
	font-size: 16px;
	font-weight: 500;
	text-decoration: none;
	&:hover {
		text-decoration: underline;
	}
	color: ${props => props.theme.textColor};
	margin: ${props => props.margin};
`;


export default class EmailAddress extends React.PureComponent {
	render() {
		let value = this.props.value;
		if (this.props.preset === 'intergram') {
			value = 'portal@intergram.cz';
		}
		if (!value) {
			return null;
		}
		return (
			<Wrapper href={'mailto:' + value} margin={this.props.margin}>{value}</Wrapper>
		);
	}
}
